/**
 * MDVIP's own corporate contact info — the support lines, HQ mailing address, and public website.
 * Single source of truth: no call site should hardcode any of these values independently. A
 * follow-up migrates the pre-existing scattered literals elsewhere in the codebase onto this
 * module. Support hours are deliberately not here: unlike the values here, hours are locale-variant
 * prose (day/time formatting), not data — they live in shared.json's `contact.callCard.hours`
 * i18n key instead, so a translation stays the single source of truth for that value.
 */
export const MDVIP_COMPANY_INFO = {
  // Two distinct lines, not aliases: members reach Member Services, practices reach the
  // physician line. Name every future number for its audience the same way.
  memberSupportPhone: '877.886.1411', // confirmed canonical support number — product decision 2026-09-04
  physicianSupportPhone: '877.734.3090',
  hqAddress: {
    line1: '4950 Communication Ave, Ste. 100',
    line2: 'Boca Raton, FL 33431',
  },
  website: 'mdvip.com',
} as const;
